export default __webpack_public_path__ + "40652dc94cd06712f2d47115ba58e8d3.jpg";